import { apiService } from "@/common/api.service.js";

export default {
  // ENPI list (assumed endpoint)
  getAllEnpi() {
    const endpoint = `/api/enpi-all/`;
    return apiService(endpoint);
  },

  // ENPI data details
  enpiData(enpiId) {
    const endpoint = `/api/enpi/${enpiId}/`;
    return apiService(endpoint);
  },

  // Nested ENPI
  nestedEnpi() {
    const endpoint = `/api/nested-enpi/`;
    return apiService(endpoint);
  },

  // Site + SEU ENPI filter
  siteSeuEnpi(payload) {
    const endpoint = `/api/enpi/?site_code__id=${payload.site_id}&seu__id=${payload.seu_id}`;
    return apiService(endpoint);
  },

  // Site ENPI filter
  siteEnpi(payload) {
    const endpoint = `/api/enpi/?site_code__id=${payload.site_id}`;
    return apiService(endpoint);
  },

  // Create ENPI
  enpiCreate(payload) {
    const endpoint = `/api/enpi-create/`;
    return apiService(endpoint, "POST", payload);
  },

  nestedSeuEnpi(site_code) {
      let endpoint = `/api/nested-seu-enpi/${site_code}/`;
      return apiService(endpoint);
  },
};
